module.exports = __webpack_public_path__ + "static/img/皮带煤量监测.b0c46e43.png";